/* loaded by smart-asset */
export default require("./pdf~zistCFwK.png")